export enum TermsAndConditionsType {
  PRIVACY_TERMS = 'privacy-terms',
  HOST_TERMS = 'host-terms',
  RENTER_TERMS = 'renter-terms',
}